import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useTransformOptions } from 'Core/hooks';
import { TextEditor } from 'Core/components/editor';
import CustomPropTypes from 'CustomPropTypes';
// import { fetchStatuses } from '../../core/redux/status/slice';
// import { fetchLabels } from '../../core/redux/label/slice';

const initData = {
  id: "0",
  userId: "",
  name: "",
  locationIdExt: "",
  description: "",
};

const LocationsAddEditForm = ({ data, onChanges, id }) => {

  const [formData, setFormData] = useState(data ? data : initData);

  const updateFormField = (fieldName, value) => {
    setFormData(prevData => ({
      ...prevData,
      [fieldName]: value,
    }));
    onChanges({ ...formData, [fieldName]: value });
  };


  return (
    <>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Name <span className="text-danger">*</span>
            </label>
            <input
              name="name"
              type="text"
              className="form-control"
              value={formData.name}
              onChange={e => updateFormField('name', e.target.value)}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Description <span className="text-danger">*</span>
            </label>
            <div className="input-groupicon calender-input">
              {/* <Calendar className="info-img" /> */}
              <input
                type="text"
                value={formData.description}
                onChange={e => updateFormField('description', e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

LocationsAddEditForm.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.shape(CustomPropTypes.locations),
  onChanges: PropTypes.func,
};

export default LocationsAddEditForm;
